import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import Slider from '../../components/slider';
import SlidegalleryItem from '../../blocks/slidegallery-item';
import './styles.css';
import Video from "../../blocks/video";
import ScrollLoader from '../../components/scroll-loader';

/**
 *  Slidegallery
 */
class Slidegallery extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    slidegalleryItem: PropTypes.arrayOf(PropTypes.node),
    thumbnail: PropTypes.bool,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    slidegalleryItem: null,
    thumbnail: null,
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      current: 0,
      openThumb: false,
    };
    this.dots = [];
    this.components = [];
  }

  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      slidegalleryItem,
      thumbnail,
    } = this.props;
    //
    let srcArr = [];
    this.props.slidegalleryItem.map((item, index) => {
      let src = null;
      let type = null;
      if (item.props.youtubeId && item.props.youtubeId !== null && item.props.youtubeId !== '') {
        if (item.props.thumbnailSrc && item.props.thumbnailSrc !== null && item.props.thumbnailSrc !== '') {
          src = item.props.thumbnailSrc;
        } else {
          src = 'https://i.ytimg.com/vi/' + item.props.youtubeId + '/mqdefault.jpg';
        }
        type = 'movie';
      } else if (item.props.thumbnailSrc && item.props.thumbnailSrc !== null && item.props.thumbnailSrc !== '') {
        src = item.props.thumbnailSrc;
        type = 'image';
      } else if (item.props.pcSrc && item.props.pcSrc !== null && item.props.pcSrc !== '') {
        src = item.props.pcSrc;
        type = 'image';
      }
      srcArr.push({
        src: src,
        type: type,
      });
    });
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <ScrollLoader>
          <div className="Slidegallery">
            <div className="Slidegallery__main">
              <Slider
                ref="slider"
                settings={{
                  autoplay: false,
                  // speed: 1000,
                  speed: 1000,
                  // ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                  // ease: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
                  ease: 'linear',
                  fade: true,
                  infinite: true,
                  initialSlide: 0,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  swipe: false,
                  draggable: false,
                  arrows: true,
                  dots: false,
                  adaptiveHeight: false,
                  //lazyLoad: 'progressive',
                  lazyLoad: 'ondemand',
                  waitForAnimate: false,
                  focusOnSelect: true,
                  beforeChange: (old, current) => {
                    if (this.refs.thumbnail) this.refs.thumbnail.slickGoTo(current);
                    setTimeout(() => {
                      this.setState({
                        current: current,
                      })
                    }, 100);
                    this.dots.map((dot, index) => {
                      if (index === current) {
                        this.refs[dot].classList.add('current');
                      } else {
                        this.refs[dot].classList.remove('current');
                      }
                    });

                    let slickList = this.refs.slider.refs.slide.getElementsByClassName('slick-list')[0];
                    slickList.classList.add('open');
                    setTimeout(() => {
                      slickList.classList.remove('open');
                    }, 500);
                    this.refs.slider.beforeChange(old, current);

                    // スライド初期化
                    let i, max;
                    for (i = 0, max = this.components.length; i < max; i = i + 1) {
                      this.components[i].initialize();
                    }

                  },
                  responsive: [
                    {
                      breakpoint: 767,
                      settings: {
                        swipe: true,
                        arrows: false,
                        prevArrow: '<div></div>',
                        nextArrow: '<div></div>',
                      },
                    },
                  ],
                }}
              >
                {this.props.slidegalleryItem.map((child, index) => {
                  // if (child.type.displayName === 'withDynamicComponents(SlidegalleryItem)') {
                  if (0 <= child.type.displayName.indexOf('withDynamicComponents(SlidegalleryItem)')) {
                    let current = false;
                    if (index === this.state.current) current = true;
                    return (
                      <SlidegalleryItem {...child.props}
                        key={index}
                        current={current}
                        getRef={(ref) => {
                          (ref) ? this.components.push(ref): null;
                        }}
                      />
                    )
                  } else {
                    return null;
                  }
                })}
                {/*{slidegalleryItem}*/}
              </Slider>
            </div>
            {(() => {
              this.dots = [];
              if (thumbnail === true) {
                if (8 <= srcArr.length) {
                  return (
                    <div className={'Slidegallery__thumbnail' + ((this.state.openThumb === true) ? ' open': '')}>
                      <div className="Slidegallery__thumbnail-link-close"
                        onClick={(e)=> {
                          e.preventDefault();
                          this.setState({
                            openThumb: false,
                          });
                        }}
                      />
                      <div className="Slidegallery__thumbnail-container">
                        <div className="Slidegallery__thumbnail-container2">
                          <Slider ref="thumbnail"
                            settings={{
                              autoplay: false,
                              speed: 500,
                              ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                              fade: false,
                              infinite: true,
                              initialSlide: 0,
                              slidesToShow: 8,
                              slidesToScroll: 1,
                              swipe: true,
                              draggable: false,
                              arrows: true,
                              dots: false,
                              adaptiveHeight: false,
                              centerMode: false,
                              centerPadding: 0,
                              focusOnSelect: true,
                              //lazyLoad: 'progressive',
                              lazyLoad: 'ondemand',
                              beforeChange: (old, current) => {
                                if (this.refs.slider) this.refs.slider.slickGoTo(current);
                              },
                            }}
                          >
                            {srcArr.map((src, index) => {
                              return (
                                <a className={'Slidegallery__thumbnail-item' + ((src.type === 'movie') ? ' movie': '')}
                                     key={index}>
                                  <span className="Slidegallery__thumbnail-item-inner"
                                       style={{backgroundImage: 'url(' + src.src + ')'}}
                                  />
                                </a>
                              )
                            })}
                          </Slider>
                        </div>
                      </div>
                      <ul className="Slidegallery__dots">
                        {this.props.slidegalleryItem.map((child, index) => {
                          this.dots.push('dot' + index);
                          return (
                            <li key={index}>
                              <a className={'Slidegallery__dots-link' + ((index === 0) ? ' current': '')}
                                 href="javascript:void(0)"
                                 onClick={(e) => {
                                   e.preventDefault();
                                   if (this.refs.slider) this.refs.slider.slickGoTo(index);
                                 }}
                                 ref={'dot' + index}
                              >
                                {index}
                              </a>
                            </li>
                          )
                        })}
                      </ul>
                      <a
                        className="Slidegallery__thumbnail-link-open"
                        href="javascript:void(0)"
                        onClick={(e) => {
                          e.preventDefault();
                          if (this.state.openThumb === true) {
                            this.setState({
                              openThumb: false,
                            });
                          } else {
                            this.setState({
                              openThumb: true,
                            });
                          }
                        }}
                      >
                        OPEN
                      </a>
                    </div>
                  )
                } else {
                  return (
                    <div className={'Slidegallery__thumbnail noSlider' + ((this.state.openThumb === true) ? ' open': '')}>
                      <div className="Slidegallery__thumbnail-link-close"
                           onClick={(e)=> {
                             e.preventDefault();
                             this.setState({
                               openThumb: false,
                             });
                           }}
                      />
                      <div className="Slidegallery__thumbnail-container">
                        <div className="Slidegallery__thumbnail-container2">
                          <ul className="Slidegallery__thumbnail-list">
                            {srcArr.map((src, index) => {
                              return (
                                <li key={index}>
                                  <a className={'Slidegallery__thumbnail-item' + ((src.type === 'movie') ? ' movie': '') + ((index === this.state.current) ? ' current': '')}
                                     href="javascript:void(0)"
                                     onClick={(e) => {
                                       e.preventDefault();
                                       if (this.refs.slider) this.refs.slider.slickGoTo(index);
                                     }}
                                  >
                                    <span className="Slidegallery__thumbnail-item-inner"
                                       style={{backgroundImage: 'url(' + src.src + ')'}}
                                    />
                                  </a>
                                </li>
                              )
                            })}
                          </ul>
                        </div>
                      </div>
                      <ul className="Slidegallery__dots">
                        {this.props.slidegalleryItem.map((child, index) => {
                          this.dots.push('dot' + index);
                          return (
                            <li key={index}>
                              <a className={'Slidegallery__dots-link' + ((index === 0) ? ' current': '')}
                                 href="javascript:void(0)"
                                 onClick={(e) => {
                                   e.preventDefault();
                                   if (this.refs.slider) this.refs.slider.slickGoTo(index);
                                 }}
                                 ref={'dot' + index}
                              >
                                {index}
                              </a>
                            </li>
                          )
                        })}
                      </ul>
                      <a className="Slidegallery__thumbnail-link-open"
                         href="javascript:void(0)"
                         onClick={(e) => {
                           e.preventDefault();
                           if (this.state.openThumb === true) {
                             this.setState({
                               openThumb: false,
                             })
                           } else {
                             this.setState({
                               openThumb: true,
                             })
                           }
                         }}
                      >
                        OPEN
                      </a>

                    </div>
                  )
                }
              } else {
                return (
                  <ul className="Slidegallery__dots">
                    {this.props.slidegalleryItem.map((child, index) => {
                      this.dots.push('dot' + index);
                      return (
                        <li key={index}>
                          <a className={'Slidegallery__dots-link' + ((index === 0) ? ' current': '')}
                             href="javascript:void(0)"
                             onClick={(e) => {
                               e.preventDefault();
                               if (this.refs.slider) this.refs.slider.slickGoTo(index);
                             }}
                             ref={'dot' + index}
                          >
                            {index}
                          </a>
                        </li>
                      )
                    })}
                  </ul>
                );
              }
            })()}
          </div>
        </ScrollLoader>
      </Wrapper>
    )
  }

}

export default Slidegallery;




// WEBPACK FOOTER //
// ./src/containers/slidegallery/index.jsx